import React from "react";

// components
import TextInput from "../../../component/element/forms/TextInput";

// state
import { useAppDispatch } from "../../../store";
import { create_type } from "../../../services/apis/opportunity";
import Modal from "../../../component/ui/modal";
import { IErrorWarning } from "../../../store/types/misc";
import { useAppSelector } from "../../../store";

type ICreateOppotunityType = {
  visible: boolean;
  onClose: () => void;
};

const CreateOppotunityType: React.FC<ICreateOppotunityType> = ({
  visible,
  onClose,
}) => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(({ opportunity }) => opportunity.loading);
  const [data, dataSet] = React.useState<{ name: string }>({ name: "" });
  const [err, errSet] = React.useState<{ name: IErrorWarning }>({ name: "" });

  const clear = () => {
    dataSet({ name: "" });
    errSet({ name: "" });
  };

  const handleOk = async () => {
    if (!data.name.trim()) {
      errSet({ name: "error: this field is required" });
      return;
    }
    const response = await create_type(data, dispatch);
    if (response) {
      clear();
      onClose();
    }
  };

  return (
    <Modal
      title="Create Type"
      open={visible}
      onClose={() => {
        clear();
        onClose();
      }}
      onOkClick={handleOk}
      isLoading={loading}
    >
      <div className="space-y-6">
        <TextInput
          type="text"
          name="name"
          label="Name"
          placeholder="Enter name"
          value={data.name}
          status={err.name}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const { name, value } = e.target;
            dataSet((prev) => ({ ...prev, [name]: value }));
            errSet((prev) => ({ ...prev, [name]: "" }));
          }}
        />
      </div>
    </Modal>
  );
};

export default CreateOppotunityType;
